import dot from 'dot-prop-immutable'

import { disconnectIntegration } from 'common/actions/integrations/common/actions/integrationActions'
import * as atypes from 'common/actions/integrations/common/constants/IntegrationsReduxActionTypes'
import {
  clearAccountLinkField,
  fetchContactFields,
  fetchForms,
  getFormById,
  setAccountLinkField,
} from 'common/actions/integrations/HubSpot/actions/hubspotActions'
import { HubSpotConfig } from 'common/actions/integrations/HubSpot/model/constants'

import { refreshFields } from '../actions/hubspotActions'

const initialState = {
  identityField: {
    value: null,
    option: null,
  },
  currentForm: '',
  forms: null,
  contactProperties: null,
  bindings: {},
  mappings: {},
  userFieldPropertiesMappings: [{ contactProperty: '', userField: '' }],
  isFetchingForms: false,
  isFetchingContactFields: false,
  isDisconnecting: false,
}

export default function integrationsReducer(state = initialState, action) {
  switch (action.type) {
    case clearAccountLinkField.fulfilled.type:
    case setAccountLinkField.fulfilled.type: {
      return dot.set(state, HubSpotConfig.type, action.payload.hubspot)
    }
    case getFormById.pending.type:
    case fetchForms.pending.type: {
      return { ...state, isFetchingForms: true }
    }

    case getFormById.rejected.type:
    case fetchForms.rejected.type: {
      return { ...state, isFetchingForms: false }
    }

    case fetchForms.fulfilled.type: {
      const { payload } = action
      return { ...state, forms: payload.forms, isFetchingForms: false }
    }

    case getFormById.fulfilled.type: {
      const { payload } = action

      return { ...state, currentForm: payload.form, isFetchingForms: false }
    }

    case fetchContactFields.pending.type: {
      return { ...state, isFetchingContactFields: true }
    }

    case fetchContactFields.fulfilled.type: {
      const { payload } = action
      return { ...state, contactProperties: payload.fields, isFetchingContactFields: false }
    }

    case atypes.HUBSPOT_SET_FORM: {
      const { data } = action
      return { ...state, currentForm: data }
    }

    case atypes.HUBSPOT_SET_FORM_BINDINGS: {
      const { data } = action
      return { ...state, bindings: { ...state.bindings, ...data } }
    }

    case atypes.HUBSPOT_SET_CONTACT_MAPPINGS: {
      const { data } = action
      return { ...state, mappings: { ...state.mappings, ...data } }
    }

    case atypes.HUBSPOT_SET_CUF_IN_MAPPINGS: {
      const { data } = action

      return {
        ...state,
        userFieldPropertiesMappings: Object.assign([], state.userFieldPropertiesMappings, {
          [data.index]: {
            ...state.userFieldPropertiesMappings[data.index],
            userField: data.value || '',
          },
        }),
      }
    }

    case atypes.HUBSPOT_SET_PROPERTY_IN_BINDINGS: {
      const { data } = action
      return {
        ...state,
        userFieldPropertiesMappings: Object.assign([], state.userFieldPropertiesMappings, {
          [data.index]: {
            ...state.userFieldPropertiesMappings[data.index],
            contactProperty: data.value || '',
          },
        }),
      }
    }

    case atypes.HUBSPOT_ADD_CUF_PROPERTY_PAIR: {
      return {
        ...state,
        userFieldPropertiesMappings: [
          ...state.userFieldPropertiesMappings,
          { contactProperty: '', userField: '' },
        ],
      }
    }

    case atypes.HUBSPOT_DELETE_CUF_PROPERTY_PAIR: {
      const { data } = action
      const newMappings = [...state.userFieldPropertiesMappings]
      newMappings.splice(data.index, 1)
      return {
        ...state,
        userFieldPropertiesMappings: newMappings,
      }
    }

    case atypes.HUBSPOT_SET_CUF_PROPERTY_BINDINGS: {
      const { data } = action

      return {
        ...state,
        userFieldPropertiesMappings: data.length ? data : initialState.userFieldPropertiesMappings,
      }
    }

    case atypes.HUBSPOT_SET_IDENTITY_FIELD: {
      const { data } = action

      return {
        ...state,
        identityField: data,
      }
    }

    case atypes.INTEGRATION_RESET: {
      return {
        ...state,
        ...initialState,
      }
    }

    case refreshFields.fulfilled.type: {
      const { payload } = action
      return {
        ...state,
        currentForm: { ...state.currentForm, fields: payload.fields },
      }
    }

    case disconnectIntegration.pending.type: {
      return { ...state, isDisconnecting: true }
    }
    case disconnectIntegration.fulfilled.type: {
      return { ...state, isDisconnecting: false }
    }
  }

  return state
}
